import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Button, Paper, Divider } from '@mui/material';
import { ArrowLeft, FileText } from 'lucide-react';
import logoPainel from '../imagens/logopainelftm.png.ico';

const Section = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h6" sx={{ color: '#fff', mb: 1.5, fontWeight: 700 }}>
      {title}
    </Typography>
    <Box sx={{ color: '#9CA3AF', lineHeight: 1.8, fontSize: '0.95rem' }}>
      {children}
    </Box>
  </Box>
);

const TermosUso = () => {
  const navigate = useNavigate();
  const updatedAt = '29 de abril de 2026';

  return (
    <Box sx={{ background: '#111827', minHeight: '100vh' }}>
      {/* Navbar */}
      <Box sx={{
        position: 'sticky', top: 0, zIndex: 1000,
        background: 'rgba(17, 24, 39, 0.85)', backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(124, 58, 237, 0.15)',
      }}>
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.5 }}>
            <Box
              sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
              onClick={() => navigate('/')}
            >
              <img src={logoPainel} alt="FTM" style={{ width: 36, height: 36, borderRadius: 8 }} />
              <Typography sx={{ fontWeight: 800, fontSize: '1.1rem', color: '#fff' }}>
                PAINEL <span style={{ color: '#7C3AED' }}>FTM</span>
              </Typography>
            </Box>
            <Button
              variant="text"
              startIcon={<ArrowLeft size={18} strokeWidth={1.75} />}
              onClick={() => navigate('/')}
              sx={{ color: '#9CA3AF', fontWeight: 600, '&:hover': { color: '#fff' } }}
            >
              Voltar
            </Button>
          </Box>
        </Container>
      </Box>

      <Container maxWidth="md" sx={{ py: { xs: 5, sm: 8 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
          <FileText size={28} strokeWidth={1.75} color="#7C3AED" />
          <Typography variant="h4" sx={{ color: '#fff', fontWeight: 800 }}>
            Termos de Uso
          </Typography>
        </Box>
        <Typography sx={{ color: '#6B7280', mb: 4, fontSize: '0.9rem' }}>
          Última atualização: {updatedAt}
        </Typography>

        <Paper sx={{ p: { xs: 3, sm: 5 }, background: '#141926', border: '1px solid rgba(255,255,255,0.06)' }}>

          <Section title="1. Aceitação dos Termos">
            Ao criar uma conta, contratar um plano ou utilizar qualquer funcionalidade do <strong style={{ color: '#fff' }}>Painel FTM</strong>,
            você declara ter lido, compreendido e aceito integralmente estes Termos de Uso e a nossa
            Política de Privacidade. Caso não concorde, você não deve utilizar a plataforma.
          </Section>

          <Section title="2. Descrição do serviço">
            O Painel FTM é uma plataforma SaaS que gera sites profissionais a partir de templates próprios,
            com infraestrutura de hospedagem inclusa, com o objetivo de auxiliar o usuário no processo
            de verificação de Business Managers (BMs) na Meta e em demais necessidades de presença digital.
            <br /><br />
            <em>Importante:</em> O Painel FTM <strong style={{ color: '#fff' }}>não é parceiro oficial, afiliado, agente ou representante</strong> da
            Meta Platforms, Inc., Facebook, Instagram, Google ou qualquer outra plataforma. Somos uma
            ferramenta independente de geração de sites.
          </Section>

          <Section title="3. Cadastro e conta">
            Para utilizar a plataforma você deve fornecer informações verdadeiras, completas e atualizadas
            (nome, e-mail, CPF, telefone). Você é responsável pela confidencialidade da sua senha e por
            todas as atividades realizadas em sua conta. Notifique-nos imediatamente em caso de uso não
            autorizado.
          </Section>

          <Section title="4. Uso permitido">
            Você concorda em utilizar o Painel FTM apenas para finalidades lícitas, em conformidade com
            estes Termos, com a legislação aplicável e com as políticas das plataformas de destino
            (Meta, Google etc.).
          </Section>

          <Section title="5. Uso proibido">
            É expressamente proibido:
            <ul style={{ marginTop: 8, paddingLeft: 20 }}>
              <li>Utilizar dados, documentos, imagens ou informações de terceiros sem autorização;</li>
              <li>Praticar fraude, falsa identidade, lavagem de dinheiro ou qualquer atividade ilícita;</li>
              <li>Distribuir malware, realizar ataques, scraping massivo ou engenharia reversa do sistema;</li>
              <li>Promover conteúdo ilegal, discriminatório, violento, sexualmente explícito envolvendo
                menores, ou que viole direitos de terceiros;</li>
              <li>Revender, sublicenciar, copiar ou modificar a plataforma sem autorização expressa;</li>
              <li>Usar a plataforma para burlar políticas de plataformas terceiras de forma fraudulenta.</li>
            </ul>
            O descumprimento poderá resultar em <strong style={{ color: '#fff' }}>suspensão ou cancelamento imediato</strong> da conta,
            sem reembolso, e nas medidas judiciais cabíveis.
          </Section>

          <Section title="6. Tokens, planos e pagamentos">
            Funcionalidades específicas podem exigir aquisição de tokens ou contratação de plano. Os
            valores, formas de pagamento e regras de consumo são exibidos no painel no momento da
            contratação. Pagamentos não autorizados ou contestados podem resultar em suspensão da conta.
          </Section>

          <Section title="7. Política de reembolso">
            Tokens consumidos para gerar sites e/ou ativar serviços <strong style={{ color: '#fff' }}>não são reembolsáveis</strong>, salvo
            disposição legal em contrário. Casos específicos previstos no Código de Defesa do Consumidor
            (ex.: arrependimento em até 7 dias, antes do uso) serão analisados conforme a lei.
          </Section>

          <Section title="8. Propriedade intelectual">
            Todo o software, design, código, marca, layout, templates e materiais do Painel FTM são de
            nossa propriedade ou licenciados a nós. Você recebe uma licença limitada, não exclusiva,
            intransferível e revogável para uso pessoal/profissional dentro da plataforma. O conteúdo
            inserido por você (textos, imagens, dados de empresa) permanece de sua propriedade, mas você
            nos concede licença para hospedá-lo e processá-lo no escopo do serviço.
          </Section>

          <Divider sx={{ borderColor: 'rgba(255,255,255,0.06)', my: 4 }} />

          <Section title="9. Declarações e responsabilidades do usuário">
            Ao utilizar o Painel FTM, você declara expressamente que:
            <ul style={{ marginTop: 8, paddingLeft: 20 }}>
              <li>
                <strong style={{ color: '#fff' }}>Utilizará apenas dados e informações próprias</strong> nos sites gerados e nas operações
                realizadas, possuindo titularidade, autorização ou licença legítima sobre todo o conteúdo
                inserido;
              </li>
              <li>
                <strong style={{ color: '#fff' }}>Não utilizará dados, identidades, documentos, marcas ou informações de terceiros</strong>
                {' '}sem autorização expressa e por escrito;
              </li>
              <li>É o único responsável pela veracidade, legalidade e adequação do conteúdo, bem como
                pelo cumprimento das políticas das plataformas de destino;</li>
              <li>Isenta o Painel FTM, seus sócios, colaboradores e parceiros de qualquer responsabilidade
                decorrente do uso indevido da plataforma ou de seus sites gerados.</li>
            </ul>
          </Section>

          <Section title="10. Limitação de responsabilidade — Banimentos e ações de plataformas">
            O Painel FTM atua como ferramenta de apoio. Por mais que nossos templates apresentem
            histórico positivo, <strong style={{ color: '#fff' }}>não podemos garantir, prometer ou assegurar resultados específicos</strong>,
            uma vez que as decisões de aprovação, manutenção, suspensão ou banimento dependem
            exclusivamente das plataformas terceiras envolvidas.
            <br /><br />
            Dessa forma, na máxima extensão permitida em lei, fica estabelecido que:
            <ul style={{ marginTop: 8, paddingLeft: 20 }}>
              <li>
                <strong style={{ color: '#fff' }}>Não nos responsabilizamos por banimentos, suspensões, restrições, desativações ou
                qualquer outra ação aplicada pela Meta (Facebook/Instagram), Google ou qualquer plataforma
                terceira</strong> sobre Business Managers (BMs), contas de anúncio, perfis pessoais, páginas,
                domínios, contas de Google Ads, contas comerciais, ou demais ativos digitais do usuário;
              </li>
              <li>Não nos responsabilizamos por reprovação na verificação de BM, alterações nas políticas
                da Meta/Google, mudanças nos critérios de avaliação ou eventuais perdas operacionais e
                financeiras decorrentes;</li>
              <li>Não nos responsabilizamos por uso indevido pelo usuário, infrações às políticas das
                plataformas, ou por consequências do uso de dados de terceiros;</li>
              <li>Estatísticas de aprovação previamente divulgadas referem-se a histórico e não constituem
                garantia de resultado futuro;</li>
              <li>Em qualquer hipótese, nossa responsabilidade total perante o usuário, na máxima extensão
                permitida em lei, fica limitada ao valor efetivamente pago por ele à plataforma nos 3 (três)
                meses anteriores ao evento que originou a reclamação.</li>
            </ul>
          </Section>

          <Section title="11. Suspensão e encerramento">
            Reservamo-nos o direito de suspender ou encerrar sua conta a qualquer momento, com ou sem
            aviso prévio, em caso de violação destes Termos, suspeita de fraude, inadimplência ou
            determinação legal. Você também pode encerrar sua conta a qualquer momento solicitando
            via suporte.
          </Section>

          <Section title="12. Alterações dos Termos">
            Estes Termos podem ser atualizados a qualquer momento. A versão vigente estará sempre disponível
            nesta página. O uso continuado da plataforma após alterações relevantes representa concordância
            com a nova versão.
          </Section>

          <Section title="13. Lei aplicável e foro">
            Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro
            da comarca da sede do Painel FTM para dirimir quaisquer controvérsias, com renúncia a qualquer
            outro, por mais privilegiado que seja.
          </Section>

          <Section title="14. Contato">
            Dúvidas, solicitações ou denúncias podem ser encaminhadas pelos canais oficiais de suporte
            disponíveis no painel.
          </Section>

        </Paper>

        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Button
            variant="outlined"
            onClick={() => navigate('/')}
            startIcon={<ArrowLeft size={18} strokeWidth={1.75} />}
            sx={{
              borderColor: 'rgba(124, 58, 237, 0.4)', color: '#A78BFA',
              '&:hover': { borderColor: '#7C3AED', background: 'rgba(124, 58, 237, 0.08)' },
            }}
          >
            Voltar para o início
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default TermosUso;
